module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("title.currentState")))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showCurrentCredit) ? _c('div', {
    staticClass: "current-state-block",
    class: {
      'col-md-12': _vm.forceFullWidthBoxes, 'col-md-6': !_vm.forceFullWidthBoxes
    }
  }, [_c('div', {
    staticClass: "pricing-list pricing-credit text-xs-left m-b-0 card-stat"
  }, [_c('div', {
    staticClass: "pricing-header",
    class: (_vm.balances.credit >= 0) ? 'bg-blue-600' : 'bg-red-600'
  }, [_c('div', {
    staticClass: "pricing-title"
  }, [_vm._v(_vm._s(_vm.$t("billing.labels.remainingCredits")))]), _vm._v(" "), _c('div', {
    staticClass: "pricing-price"
  }, [_c('span', {
    staticClass: "pricing-amount"
  }, [_vm._v(_vm._s(_vm.balances.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), (_vm.showLastAddedCredit) ? _c('p', {
    staticClass: "p-x-30 p-b-25"
  }, [_vm._v(_vm._s(_vm.$t("currentCredit.lastedTransaction")) + " : " + _vm._s(_vm.balances.latest_refill_transaction.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + " " + _vm._s(_vm.$t("text.on")) + " " + _vm._s(_vm.latestRefillDate) + " ")]) : _c('p', {
    staticClass: "p-x-30 p-b-25"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("currentCredit.textGuide")))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showCurrentCredit && _vm.isPrePaidTeam) ? _c('div', {
    staticClass: "current-state-block",
    class: {
      'col-md-12': _vm.forceFullWidthBoxes, 'col-md-6': !_vm.forceFullWidthBoxes
    }
  }, [_c('div', {
    staticClass: "bg-white p-30 card-stat"
  }, [_c('div', {
    staticClass: "counter counter-md text-xs-left"
  }, [_c('div', {
    staticClass: "counter-label text-uppercase m-b-5"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("billing.labels.currentMonthUsage")) + "\n            "), (_vm.showDiscount && (_vm.team.discount > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.perfixDiscount")) + " " + _vm._s(_vm.team.discount) + "% " + _vm._s(_vm.$t("billing.labels.subfixDiscount")) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showDiscount && (_vm.team.discount <= 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.noDiscount")) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "counter-number-group m-b-10"
  }, [_c('span', {
    staticClass: "counter-number"
  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), _c('div', {
    staticClass: "counter-label"
  }, [_c('div', {
    staticClass: "progress progress-xs m-b-10"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-info",
    class: (_vm.usagePercentage <= 80) ? 'bg-primary' : 'bg-danger',
    style: ({
      width: _vm.usagePercentage + '%'
    }),
    attrs: {
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("\n               \n              ")])]), _vm._v(" "), (_vm.showUsagePercentage) ? _c('div', {
    staticClass: "counter counter-sm text-xs-left m-t-30"
  }, [(_vm.usagePercentage < 100) ? _c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number",
    class: (_vm.usagePercentage <= 80) ? 'blue-600' : 'red-600'
  }, [_vm._v(_vm._s(_vm.usagePercentage) + "%")]), _vm._v(" "), _c('span', {
    staticClass: "counter-number-related"
  }, [_vm._v(_vm._s(_vm.$t("currentCredit.percentageBar")))])]) : _vm._e(), _vm._v(" "), (_vm.usagePercentage >= 100) ? _c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number red-600"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.creditNotEnough")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "counter-number-group m-t-10"
  }, [_c('span', {
    staticClass: "counter-number-related"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + " : " + _vm._s(_vm.upcomingBillDate) + " "), _c('a', {
    staticClass: "btn btn-link p-0 grey-100 font-size-12",
    attrs: {
      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
    }
  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])])])]) : _c('div', {
    staticClass: "counter counter-sm text-xs-left m-t-30"
  }, [_c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number-related"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide")) + " "), (_vm.balances.latest_bill_id) ? _c('span', [_c('a', {
    staticClass: "btn btn-link p-0 grey-100 font-size-12",
    attrs: {
      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
    }
  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])]) : _vm._e()])])])])])])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "p-30 bg-primary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "font-size-24 m-b-5"
  }, [_vm._v(_vm._s(_vm.$t("billing.labels.currentMonthUsage")))]), _vm._v(" "), (_vm.showUsagePercentage) ? _c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + " : " + _vm._s(_vm.upcomingBillDate) + " "), _c('a', {
    staticClass: "btn btn-link p-0 grey-100 font-size-12",
    attrs: {
      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
    }
  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])])]) : _c('div', [_c('span', {
    staticClass: "counter-number-related"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide"))), (_vm.balances.latest_bill_id) ? _c('span', [_c('a', {
    staticClass: "btn btn-link p-0 grey-100 font-size-12",
    attrs: {
      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
    }
  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "counter counter-lg text-xs-right"
  }, [_c('span', {
    staticClass: "counter-number white"
  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-808accf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/MainCurrentState.vue
// module id = 550
// module chunks = 1